import { motion } from "framer-motion";
import { ASSETS } from "@/constants/assets";

export const FeatureSection = ({ reverse, image, label, title, description, features, logoOverlay }) => (
  <section className="relative z-[1] py-28 lg:py-36 px-6 lg:px-12 overflow-hidden">
    <div className="logo-watermark-section">
      <img src={ASSETS.logo} alt="" className="logo-glow-intense" />
    </div>
    <div className="max-w-[1200px] mx-auto relative z-[2]">
      <div className={`grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center ${reverse ? 'direction-rtl' : ''}`}>
        <motion.div
          className={`feature-img aspect-[4/5] ${reverse ? 'lg:order-2' : ''}`}
          initial={{ opacity: 0, x: reverse ? 30 : -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <img src={image} alt={title} className="w-full h-full object-cover" />
          {logoOverlay && (
            <img
              src={ASSETS.logo}
              alt=""
              className="absolute bottom-6 right-6 w-[90px] h-[90px] pointer-events-none logo-glow-intense"
            />
          )}
        </motion.div>

        <motion.div
          className={`${reverse ? 'lg:order-1' : ''} bg-[rgba(3,11,24,0.92)] p-8 rounded-xl`}
          initial={{ opacity: 0, x: reverse ? -30 : 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <div className="font-orbitron text-sm font-semibold tracking-[5px] uppercase text-[#60A5FA] mb-4 text-shadow">
            {label}
          </div>
          <h3 className="font-orbitron text-2xl lg:text-3xl font-bold tracking-[2px] mb-5 text-white text-shadow">
            {title}
          </h3>
          {description.map((p, i) => (
            <p key={i} className="font-outfit text-xl leading-relaxed text-white/90 font-light mb-5">
              {p}
            </p>
          ))}
          <ul className="list-none flex flex-col gap-3 mt-4">
            {features.map((feat, i) => (
              <li key={i} className="font-outfit text-lg text-white/80 pl-6 relative font-light">
                <span className="absolute left-0 text-[#60A5FA] text-xl">▸</span>
                {feat}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </div>
  </section>
);
